import { common as koCommon } from './ko/common';
import { common as enCommon } from './en/common';

export default {
  ko: {
    common: koCommon,
  },
  en: {
    common: enCommon,
  },
};
